import { render, staticRenderFns } from "./DeviceRowMobile.vue?vue&type=template&id=f184f28a&scoped=true&"
import script from "./DeviceRowMobile.vue?vue&type=script&lang=ts&"
export * from "./DeviceRowMobile.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceRowMobile.vue?vue&type=style&index=0&id=f184f28a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f184f28a",
  null
  
)

export default component.exports